"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.arctEntitySchema = void 0;
const yup = __importStar(require("yup"));
const utilities_1 = require("../../../../../utilities");
const enums_1 = require("../../../../../enums");
exports.arctEntitySchema = yup.object().shape({
    id: yup.string().notRequired(),
    arTrack: yup.string().notRequired(),
    arct: yup
        .string()
        .nullable()
        .test('validate-duration', 'Show time should be between 00:00 and 23:00', utilities_1.validateOtherTimes)
        .notRequired(),
    blockAltitude: yup.string().notRequired(),
    rendevousType: yup.string().nullable().oneOf((0, utilities_1.getEnumValues)(enums_1.RendevousType)).notRequired(),
    timeOnTrack: yup.string().notRequired(),
    offloadAmount: yup.number().notRequired(),
    onloadAmount: yup.number().notRequired(),
    receiverType: yup.string().notRequired(),
    receiverNumber: yup.number().notRequired(),
    receiverCallSign: yup.array().of(yup.string()).notRequired(),
    route: yup.string().notRequired(),
    onStation: yup
        .string()
        .nullable()
        .test('validate-duration', 'Show time should be between 00:00 and 23:00', utilities_1.validateOtherTimes)
        .notRequired(),
    offStation: yup
        .string()
        .nullable()
        .test('validate-duration', 'Show time should be between 00:00 and 23:00', utilities_1.validateOtherTimes)
        .notRequired(),
});
